
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#e6e6e6"}}),_c('polyline',{attrs:{"points":"62.12 30.86 50.05 30.86 50.05 45.07 35.83 45.07 35.83 57.15 50.05 57.15 50.05 71.36 62.12 71.36 62.12 57.15 76.33 57.15 76.33 45.07 62.12 45.07 62.12 36.92","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('polyline',{attrs:{"points":"63.07 83.33 63.07 99.89 82.56 99.89 82.56 119.39 99.12 119.39 99.12 99.89 118.62 99.89 118.62 83.33 99.12 83.33 99.12 63.83 82.56 63.83 82.56 83.33 73.56 83.33","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    